import PropTypes from 'prop-types';
import React from 'react';
import VirtualList from 'react-tiny-virtual-list';

const ITEM_SIZE = 30;

const MenuList = ({ children = [], maxHeight = 300 }) => {
    const elementIsHidden = element => {
        let ret = false;
        const { parentNode } = element;
        const elementTop = parseInt(parentNode.style.top, 10);
        const elementBottom = elementTop + parentNode.offsetHeight;

        const containerNode = parentNode.parentNode.parentNode;
        const containerTop = containerNode.scrollTop;
        const containerBottom = containerTop + containerNode.offsetHeight;

        if (elementBottom <= containerTop || elementTop >= containerBottom) {
            ret = true;
        }
        return ret;
    };

    const flatGroups = () => {
        const flattened = [];
        const childrenArr = React.Children.toArray(children);
        for (const child of childrenArr) {
            flattened.push(child);
            if (
                (!child.props.type && child.props.children !== 'No options') ||
                (child.props.type !== 'option' && Array.isArray(child.props.children))
            ) {
                flattened.push(...child.props.children);
            }
        }
        return flattened;
    };

    const childrenArr = flatGroups();
    const height = childrenArr.length ? Math.min(ITEM_SIZE * childrenArr.length, maxHeight) : ITEM_SIZE;
    let scrollToIndex = null;
    const focused = childrenArr.findIndex(item => item.props && item.props.isFocused);
    if (focused !== -1) {
        try {
            const element = document.querySelector(`#${childrenArr[focused].props.innerProps.id}`);
            if (!element) {
                scrollToIndex = focused;
            } else if (elementIsHidden(element)) {
                scrollToIndex = focused;
            }
        } catch (e) {
            console.warn('[MenuList] failed to calculate scrollIndex');
        }
    }

    return (
        <VirtualList
            width="100%"
            height={height}
            itemCount={childrenArr.length || 1}
            itemSize={ITEM_SIZE}
            renderItem={({ index, style }) => {
                return (
                    <div key={index} style={style}>
                        {childrenArr[index]}
                    </div>
                );
            }}
            scrollToIndex={scrollToIndex}
        />
    );
};

MenuList.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
    maxHeight: PropTypes.number,
};

export default MenuList;
